<div class="wrapper">
    <app-header></app-header>
    <div class="main">
        <div class="container-fluid container-fluid-5">
            <div class="row row5">
                <div class="sidebar col-md-2 hide-small">
                    <app-sidebar></app-sidebar>
                </div>
                <div class="col-12 hide-large featured-box">
                </div>
                <div class="col-md-10 report-main-content m-t-5">
                  <div class="card">
                    <div class="card-header"><h4 class="mb-0">Un-Setteled Bet</h4></div>
                    <div class="card-body container-fluid container-fluid-5">
                      <div class="row row5">
                        <div class="col-12">
                          <div id="match_unmatched_delete" class="radio-group" role="radiogroup" tabindex="-1">
                            <div class="custom-control custom-control-inline custom-radio">
                              <input id="matched" type="radio" name="match_unmatched_delete" autocomplete="off" value="1" class="custom-control-input" checked> 
                              <label for="matched" class="custom-control-label"><span>Matched</span></label>
                            </div> 
                            <div class="custom-control custom-control-inline custom-radio">
                              <input id="unmatched" type="radio" name="match_unmatched_delete" autocomplete="off" value="2" class="custom-control-input"> 
                              <label for="unmatched" class="custom-control-label"><span>Un-Matched</span></label>
                            </div> 
                            <div class="custom-control custom-control-inline custom-radio">
                              <input id="deleteed" type="radio" name="match_unmatched_delete" autocomplete="off" value="3" class="custom-control-input"> 
                              <label for="deleteed" class="custom-control-label"><span>Deleted</span></label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row row5 mt-2 hide-small">
                          <div class="col-12 account-statement-tbl">
                            <div class="table-responsive">
                              <table class="table b-table table-striped table-bordered">
                                <thead>
                                  <tr class="text-center">
                                      <th class="text-right">No.</th>
                                      <th class="text-center">Event Name</th>
                                      <th class="text-center">Nation</th>
                                      <th class="text-center">Event Type</th>
                                      <th class="text-center">Market Name</th>
                                      <th class="text-center">Side</th>
                                      <th class="text-center">Rate</th>
                                      <th class="text-right">Amount</th>
                                      <th class="text-center">Place Date</th>
                                      <th class="text-center">Match Date</th>
                                  </tr>
                                </thead>
                                <tbody *ngIf="settledBetData?.length != 0">
                                  <ng-container *ngFor="let data of settledBetData;let i = index;" style="text-align: center;">
                                  <tr  [ngClass]="{'back':data?.is_back == 1,'lay':data?.is_back == 0}">
                                      <td class="text-right">{{i+1}}</td>
                                      <td class="text-center">{{data?.match_name}}</td>
                                      <td class="text-center">{{data.is_fancy == 0 ? data.selection_name : (data.market_name)}} </td>
                                      <td class="text-center">{{data?.sport_name}}</td>
                                      <td class="text-center">{{data?.market_name}}</td>
                                      <td class="text-center" *ngIf="data.is_fancy == 0">{{ data.is_back == 1 ? 'Back' : 'Lay'}}</td>
                                      <td class="text-center" *ngIf="data.is_fancy == 1">{{ data.is_back == 1 ? 'Yes' : 'No'}}</td>
                                      <td class="text-center"> {{data.odds}}</td>
                                      <td class="text-right">{{data?.stack}}</td>
                                      <td class="text-center">{{data.createdAt| date :'dd-MM-yyyy hh:mm:ss aa'}}</td>
                                      <td class="text-center">{{data.createdAt| date :'dd-MM-yyyy hh:mm:ss aa'}}</td>
                                  </tr>
                                </ng-container>
                                </tbody>
                                <tbody *ngIf="settledBetData?.length == 0">
                                  <tr>
                                    <td class="no-data-available" colspan="10">No data!</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                      </div>

                      <div class="row row5 mt-2 hide-large" *ngIf="settledBetData?.length != 0">
                        <div class="col-12">
                          <ng-container *ngFor="let data of settledBetData;let i = index;" style="text-align: center;">
                            <div class="unsetteled-bet" [ngClass]="{'back':data?.is_back == 1,'lay':data?.is_back == 0}">
                              <div class="row row5">
                                <div class="col-6">
                                  <div>
                                    <a><b>{{data?.match_name}}</b></a>
                                  </div>
                                  <div>
                                    <strong>Event Type: </strong>
                                    {{data?.sport_name}}
                                  </div>
                                  <div>
                                    <strong>Market Name: </strong>
                                    {{data?.market_name}}
                                  </div>
                                  <div>
                                    <strong>Place Date: </strong>
                                    {{data.createdAt| date :'dd-MM-yyyy hh:mm:ss aa'}}
                                  </div>
                                  <div>
                                    <strong>Matched Date:</strong>
                                    {{data.createdAt| date :'dd-MM-yyyy hh:mm:ss aa'}}
                                  </div>
                                </div>
                                <div class="col-2">
                                  <div><b>Nation</b></div>
                                  <div>{{data.is_fancy == 0 ? data.selection_name : (data.market_name)}}</div>
                                </div>
                                <div class="col-2 text-right">
                                  <div><b>Rate</b></div>
                                  <div>{{data.odds}}</div>
                                </div>
                                <div class="col-2 text-right">
                                  <div><b>Amount</b></div>
                                  <div>{{data?.stack}}</div>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                      <div class="row row5 mt-2 hide-large" *ngIf="settledBetData?.length == 0">
                        <div class="col-12">
                            <p class="mb-0 text-center">
                              There are no records to show
                            </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
  </div>
  
<app-footer-main></app-footer-main>

  
  